"use client";

import Logos from "@/components/logos";
import "./landing.css";
import {
  Hero,
  Step1,
  Step2,
  Step3,
  Step4,
  ProductsSection,
  MissionCta,
  Footer,
} from "./_components/sections";
import { LandingHeader } from "./_components/landing-header";

export default function Home() {
  return (
    <div className="md-landing">
      <LandingHeader />
      <div>
        <Hero />
        <div className="journey" data-journey="rail">
          <Step1 />
          <Step2 />
          <Step3 />
          <Step4 />
        </div>
        <ProductsSection />
        <Logos />
        <MissionCta />
      </div>
      <Footer />
    </div>
  );
}
